/**
 * Request and response models for Group Inbox configuration APIs.
 *
 * @module groupInboxConfigTypes
 */

/** Supported Group Inbox configuration sources. */
export const GROUP_INBOX_ROUTES = {
  RPA: "rpa",
  API: "api",
} as const;

/** Group Inbox configuration source accepted by the backend. */
export type GroupInboxRoute =
  (typeof GROUP_INBOX_ROUTES)[keyof typeof GROUP_INBOX_ROUTES];

/** Body for POST `/commons/configs/group-inbox`. */
export interface GroupInboxConfigRequest {
  /** Organization whose Group Inbox configurations should be returned. */
  org_id: string;
  /** Configuration source; defaults to `rpa` in the backend. */
  route?: GroupInboxRoute;
}

/** Arbitrary fields stored in one versioned Group Inbox configuration document. */
export type GroupInboxConfigDocument = Record<string, unknown>;

/**
 * One configuration result keyed by its view-tab version.
 *
 * The backend returns each list item as `{ [viewTabVersion]: configDocument }`.
 */
export type GroupInboxConfigEntry = Record<string, GroupInboxConfigDocument>;

/** Response from POST `/commons/configs/group-inbox`. */
export interface GroupInboxConfigsResponse {
  /** Application status mirrored from the HTTP response. */
  status_code: number;
  /** Organization identifier echoed by the backend. */
  org_id: string;
  /** Configuration source queried by the backend. */
  route: GroupInboxRoute;
  /** Latest configuration for each eligible Group Inbox view tab. */
  configs: GroupInboxConfigEntry[];
}
